import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { NavItem } from '../../Data/Navigation';
import './Breadcrumb.css';
import { formatString, isNumber } from '../../Utility/Utility';

interface BreadcrumbProps {
    navigationData: NavItem[];
}

const Breadcrumb: React.FC<BreadcrumbProps> = ({ navigationData }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const params = useParams();
    const [breadcrumbs, setBreadcrumbs] = useState<any[]>([]);

    // console.log("breadcrumbs", breadcrumbs);

    useEffect(() => {
        const findBreadcrumbs = (items: NavItem[], path: string): any[] | null => {
            const matchDynamicPath = (itemPath: string, currentPath: string) => {
                // Convert route pattern to regex pattern
                const pattern = itemPath
                    .replace(/:[a-zA-Z-]+/g, '[^/]+') // Match any parameter like :id, :qty, :item-code
                    .replace(/\//g, '\\/'); // Escape forward slashes
                
                const regExp = new RegExp(`^${pattern}$`);
                return regExp.test(currentPath);
            };

            for (const item of items) {
                // Check for exact match or dynamic route match
                if (item.link === path || matchDynamicPath(item.link, path)) {
                    let breadcrumb = item.breadcrumb ? [...item.breadcrumb] : null;
                    
                    // If we have a match and there are route parameters
                    if (breadcrumb && Object.keys(params).length > 0) {
                        const paramValues = Object.values(params);
                        if (paramValues.length > 0) {
                            // Add the ID as a new breadcrumb item
                            breadcrumb.push({
                                name: (isNumber(paramValues[0]))?(paramValues[0] && paramValues[0].toString()): formatString(paramValues[0]),
                                link: ""
                            });
                        }
                    }
                    
                    return breadcrumb;
                }

                // Check children recursively
                if (item.children?.length) {
                    for (const child of item.children) {
                        const childBreadcrumbs = findBreadcrumbs([child], path);
                        if (childBreadcrumbs) return childBreadcrumbs;
                    }
                }
            }
            return null;
        };

        console.log("Current path:", location.pathname);
        const currentBreadcrumbs = findBreadcrumbs(navigationData, location.pathname);
        console.log("Found breadcrumbs for path:", currentBreadcrumbs);
        
        if (currentBreadcrumbs) {
            setBreadcrumbs(currentBreadcrumbs);
        }
    }, [location.pathname, navigationData, params]);

    const handleNavigation = (link: string, index: number) => {
        if (link) {
            navigate(`/${link}`);
        }
    };

    return (
        <nav aria-label="breadcrumb">
            <div className="breadcrumb-container mt-1 bg-white rounded py-1 px-2">
                <ol className="breadcrumb">
                    {breadcrumbs.map((item, index) => (
                        <li
                            key={index}
                            className={`breadcrumb-item ${index === breadcrumbs.length - 1 ? 'active' : '' } ${item?.link ? 'active-breadcrumb-link' : '' }` }
                        >
                            <span
                                onClick={() => handleNavigation(item.link, index)}
                                className={index === breadcrumbs.length - 1 ? 'breadcrumb-text' : 'breadcrumb-link'}
                            >
                                {item.name}
                            </span>
                            {index < breadcrumbs.length - 1 && (
                                <span className="breadcrumb-separator">{'>'}</span>
                            )}
                        </li>
                    ))}
                </ol>
            </div>
        </nav>
    );
};

export default Breadcrumb;
